/**
 * 国际区号与国家（与前台 SaiApplyFormStep1 电话区号一致）
 */
export const PHONE_COUNTRY_OPTIONS = [
  { k: '中国', c: '+86' },
  { k: '美国', c: '+1' },
  { k: '西班牙', c: '+34' },
  { k: '英国', c: '+44' },
  { k: '意大利', c: '+39' },
  { k: '哈萨克斯坦', c: '+7' },
  { k: '以色列', c: '+972' },
  { k: '捷克', c: '+420' },
  { k: '日本', c: '+81' },
  { k: '瑞典', c: '+46' },
  { k: '加拿大', c: '+1' },
  { k: '巴西', c: '+55' },
  { k: '保加利亚', c: '+359' },
  { k: '南非', c: '+27' },
  { k: '澳大利亚', c: '+61' },
  { k: '墨西哥', c: '+52' },
  { k: '法国', c: '+33' },
  { k: '哥伦比亚', c: '+57' },
  { k: '新加坡', c: '+65' },
  { k: '丹麦', c: '+45' },
  { k: '瑞士', c: '+41' },
  { k: '乌兹别克斯坦', c: '+998' },
  { k: '葡萄牙', c: '+351' },
  { k: '埃及', c: '+20' },
  { k: '新西兰', c: '+64' },
  { k: '德国', c: '+49' },
  { k: '希腊', c: '+30' },
  { k: '阿根廷', c: '+54' },
  { k: '中国香港', c: '+852' },
  { k: '阿尔及利亚', c: '+213' },
  { k: '乌克兰', c: '+380' },
  { k: '荷兰', c: '+31' },
  { k: '比利时', c: '+32' },
  { k: '奥地利', c: '+43' },
  { k: '格鲁吉亚', c: '+995' },
  { k: '阿塞拜疆', c: '+994' },
  { k: '土耳其', c: '+90' },
  { k: '爱沙尼亚', c: '+372' },
  { k: '秘鲁', c: '+51' },
  { k: '爱尔兰', c: '+353' },
  { k: '波兰', c: '+48' },
  { k: '俄罗斯', c: '+7' },
];
